import styles from './style.module.scss';

interface Props {
    /** How the unit price is made up, e.g. "$30 per 50 applicants". */
    breakdown: string;
    total: number;
};

/** Price box every extra service modal shows under its quantity dropdown. */
function PriceSummary({ breakdown, total }: Props) {
    return (
        <div className={styles.calc}>
            <h6>{breakdown}</h6>
            <h4>${total}.00</h4>
        </div>
    );
};

export default PriceSummary;
